import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export const sliderAnywhere = (function () {
  const init = function () {
    const swiper = new Swiper(".slider-anywhere", {
      modules: [Navigation, Pagination],
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: "true",
        type: "bullets",
        bulletElement: "button",
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 60,
        },
        1025: {
          slidesPerView: 3,
          spaceBetween: 60,
        },
        1680: {
          slidesPerView: "auto",
          spaceBetween: 0,
          allowTouchMove: false,
        },
      },
    });
  };

  return {
    init,
  };
})();
